export const getPaymentMethods = (state) => {
  if (!state.paymentMethods) {
    return null;
  }
	return state.paymentMethods;
};

export const getSelectedMethod = (state) => {
  return state.selectedMethod;
}
